import {useState} from "react";
import {ViewContext} from "../Context/ViewContext";

export const ViewProvider = ({ children }) => {
    const [view, setView] = useState('simple')
    const [loader, setLoader] = useState(true)
    const showLoader = () => setLoader(true);
    const hideLoader = () => setLoader(false);
    const toggleView = () => {
        setView(view === 'simple' ? 'double' : 'simple')
    }

    return (
        <ViewContext.Provider value={{ view, setView, toggleView, loader, showLoader, hideLoader }}>
            {children}
        </ViewContext.Provider>
    )
}